// Source of truth for what dev mode unlocks. Exported so the doc
// build (`development-mode.md`) can render it automatically — keep
// this object pure data with no runtime dependencies.
export const devFeatureReasons = {
  indicator: 'Shows the yellow "dev mode" indicator in the main navbar.',
  appearance:
    'Shows the "Appearance" page in settings, used to customize the organization\'s branding.',
  'feature-flags':
    'Adds a panel in personal settings for locally overriding Unleash feature flags.',
  'discovery-calls':
    'Adds the discovery-call survey controls to personal settings.',
  'labs-config':
    "Shows another user's Labs configuration on their user-info page.",
  'console-log':
    'Logs extra debug output to the browser console (metrics, latency timers, OpenTelemetry spans).',
  'external-stores':
    'Enables external hook-template stores in the extension creation flow (also requires the `hook_interfaces` backend feature).',
  'edit-mode-settings':
    'Shows the "Edit mode" tab in queue settings for configuring ui_edit_* attributes and edit values.',
  'validate-explain':
    "Appends ?explain=true to the annotation /content/validate endpoint so the response includes the request's OpenTelemetry spans for debugging validation performance.",
};

export const isDevFeatureEnabled = (_feature: keyof typeof devFeatureReasons) =>
  window.localStorage.getItem('devFeaturesEnabled') || false;
